diy.angular.registerFactory('diyfmfileitemmodel', [
    '$q', 
    'diyfmitemmodel', 
    'diyfmsourcestorage', 
    'diyfmuploadqueue', 
    'diywebsiteid', 
    'diyimageresize',
function(
    $q, 
    diyfmitemmodel, 
    diyfmsourcestorage, 
    diyfmuploadqueue, 
    diywebsiteid, 
    diyimageresize 
){
    
    var 
        fileResource = diyfmsourcestorage.getItemsProvider()
    ;

    // constructor
    var diyfmfileitemmodel = function (itemResource) {
        
        if (!itemResource) {
            itemResource = new fileResource();
        }
        
        diyfmitemmodel.call(this, itemResource, diyfmsourcestorage); //call parent constructor
        
        this._uploadProgress = undefined;
        this._uploadedThumb = undefined;
    };
    
    // diyfmfileitemmodel extends diyfmitemmodel
    diyfmfileitemmodel.prototype = Object.create(diyfmitemmodel.prototype);
    
    // public methods
    angular.extend(diyfmfileitemmodel.prototype, {
        setName: function(name) {
            this._itemResource.publicName = name;
        },
        
        getName: function() {
            return this._itemResource.publicName;
        },
        
        getFolderId: function() {
            return this._itemResource.folderId;
        },
        
        setFolderId: function(folderId) {
            this._itemResource.folderId = folderId;
        },
        
        $delete: function() {
            return this._itemResource.$delete();
        },
        
        $create: function(file) {
            var self = this, defer = $q.defer();
            this._uploadProgress = 0;
            this._uploadedFile = file;
            
            // normalize folderId
            if (typeof this._itemResource.folderId === 'undefined') {
                this._itemResource.folderId = null;
            }

            diyfmuploadqueue.get('storageFiles').add({
                file: file,
                data: {
                    publicName: this.getName(),
                    folderId: this.getFolderId()
                },
                url: '/rest/websites/' + diywebsiteid + '/storage-files'
            }).then(function(responseText) {
                self.setResource(new fileResource(JSON.parse(responseText)));
                self._uploadedFile = undefined;
                self._uploadedThumb = undefined;
                defer.resolve(self);
            }, function(w) { // propagate errors further
                self._uploadedFile = undefined;
                self._uploadedThumb = undefined;
                defer.reject(w);
            }, function(progress) {
                self._uploadProgress = progress;
                defer.notify(progress);
            });
            return defer.promise;
        }, 
        
        getUploadedThumb: function() {
            var self = this;
            var deferred = $q.defer();
            var uploadedFile = this._uploadedFile;
            if (uploadedFile) {
                if (this._uploadedThumb) {
                    deferred.resolve(this._uploadedThumb);
                } else {
                    diyimageresize.getImageByFile(uploadedFile).then(function(img) {
                        self._uploadedThumb = diyimageresize.resize(img, 200, 200);
                        deferred.resolve(self._uploadedThumb);
                    });
                }
                return deferred.promise;
            }
        },
        
        getUploadProgress: function() {
            return this._uploadProgress;
        },
        
        $update: function() {
            return this._itemResource.$update();
        },

        canMove: function() {
            return true;
        },

        hasName: function() {
            return true;
        }
    });
    
    return diyfmfileitemmodel;
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/models/diyfmfileitemmodel.js
 ** module id = 959
 ** module chunks = 0
 **/